module.exports = __webpack_public_path__ + "img/team-05.aa762547.jpg";